// Build data
const { backendUrl } = require('../rv_data.js') || {}
// Vue
import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'
Vue.use(Router)

const routes = [
  {
    path: '*',
    redirect: '/'
  },
  {
    path: '/',
    component: () => import(/* webpackChunkName: "all" */ './views/All.vue'),
    children: [
      {
        path: '/',
        name: 'home',
        component: () => import(/* webpackChunkName: "home" */ './views/Home.vue')
      },
      {
        path: '/main-menu',
        name: 'main-menu',
        component: () => import(/* webpackChunkName: "main-menu" */ './views/MainMenu.vue')
      },
      {
        path: '/areas-of-interest',
        name: 'area-of-interest',
        component: () => import(/* webpackChunkName: "area-of-interest" */ './views/AreaOfInterest.vue'),
      },
      {
        path: '/areas-of-interest/:aoi_id',
        name: 'aoi-sublevel',
        component: () => import(/* webpackChunkName: "aoi-sublevel" */ './views/AreaOfInterest.vue')
      },
      // For Articles, Videos, and Galleries
      {
        path: '/areas-of-interest/:aoi_id/:media_id',
        name: 'aoi-media',
        component: () => import(/* webpackChunkName: "aoi-media" */ './views/Media.vue')
      },
      // For Groups and Single-access 360s
      {
        path: '/areas-of-interest/:aoi_id/:media_id/:panorama_id',
        name: 'aoi-panorama',
        component: () => import(/* webpackChunkName: "aoi-panorama" */ './views/Media.vue'),
        children: [
          // For contentspots
          {
            path: ':contentspot_id',
            name: 'aoi-contentspot',
            component: () => import(/* webpackChunkName: "aoi-contentspot" */ './views/Contentspot.vue')
          },
        ]
      },

      // For Groups and Single-access 360s
      {
        path: '/guided-tour',
        name: 'guided-tour',
        component: () => import(/* webpackChunkName: "guided-tour" */ './views/GuidedTour.vue'),
      },
      {
        path: '/guided-tour/:panorama_id',
        name: 'gt-panorama',
        component: () => import(/* webpackChunkName: "gt-panorama" */ './views/Media.vue'),
        children: [
          // For contentspots
          {
            path: ':contentspot_id',
            name: 'gt-contentspot',
            component: () => import(/* webpackChunkName: "gt-contentspot" */ './views/Contentspot.vue')
          }
        ]
      },

      // Just explore - Single-access 360s
      {
        path: '/just-explore/:panorama_id',
        name: 'je-panorama',
        component: () => import(/* webpackChunkName: "je-panorama" */ './views/Media.vue'),
        children: [
          // For contentspots
          {
            path: ':contentspot_id',
            name: 'je-contentspot',
            component: () => import(/* webpackChunkName: "je-contentspot" */ './views/Contentspot.vue')
          }
        ]
      }
    ]
  }
]

const router = new Router({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  if (!store.state.posts.length) {
    Promise.all([
      fetch(`${backendUrl}rv/v1/basis?per_page=-1`)
        .then(res => res.json()),
      fetch(`${backendUrl}acf/v3/options/site-options`)
        .then(options => options.json()),
      fetch(`${backendUrl}acf/v3/options/admin-settings`)
        .then(settings => settings.json())
    ])
      .then(([restBasis, restOptions, restSettings]) => {
        store.commit({
          type: 'populate',
          basis: restBasis,
          options: restOptions,
          settings: restSettings,
          error: null
        })
        store.commit('route', to)
        next()
        store.commit('isLoading', false)
      })
      .catch((err) => {
        store.commit({
          type: 'populate',
          error: err
        })
      })
  } else {
    store.commit('isLoading', true)
    next()
    store.commit('route', to)
    store.commit('isLoading', false)
    store.commit('menuModalOpen', false)
  }

  // Since Just Explore has multiple entry points, we can save where this is coming from for the back button
  const fromName = from.name
  const toName = to.name
  if (fromName && toName) {
    const comingFromJustExplore = ['je-panorama', 'je-contentspot'].includes(fromName)
    const goingToJustExplore = toName === 'je-panorama'
    if (!comingFromJustExplore && goingToJustExplore) {
      store.commit('justExploreBack', from)
    } else if (!goingToJustExplore && comingFromJustExplore) {
      store.commit('justExploreBack')
    }
  }
})

export default router
